import * as React from "react";

import "./analytics-address-list-modal.scss";
import {faClose, faCheck, faWarning, faBan}   from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                      from "@fortawesome/react-fontawesome";
import {formatDate1}                          from "@Common/ui-components/format-date";
import {titleCase}                            from "../analytics-leads/analytics-lead-card/analytics-lead-card";
import {xdQAAttribute}                        from "../analytics-layout";

export const AnalyticsAddressListModal = ({
    addressListMessage, setAddressListMessage,
    addressListLeadsExcluded, setAddressListLeadsExcluded,
    addressListLeadsIncluded, setAddressListLeadsIncluded,
    createMailingList
}) => {

    const subHeaderLeadsExcluded = () => {
        if(!Array.isArray(addressListLeadsExcluded)) {
            return null
        }

        if(addressListLeadsExcluded.length == 0) {
            return null
        }

        const usePlural = addressListLeadsExcluded.length > 1
        switch(addressListMessage) {
            case ADDRESS_LIST_MESSAGE.PENDING:
                if(usePlural) {
                    return (`The selected records lack an address and cannot be added to an address list.
                        Create the list without these records?`)
                }
                return (`The selected record lacks an address and cannot be added to an address list.
                    Create the list without this record?`)
            case ADDRESS_LIST_MESSAGE.INVALID:
                if(usePlural) {
                    return (`The selected records lack an address and cannot be added to an address list.`)
                }
                return (`The selected record lacks an address and cannot be added to an address list.`)
            case ADDRESS_LIST_MESSAGE.VALID:
            case ADDRESS_LIST_MESSAGE.ERROR:
            case ADDRESS_LIST_MESSAGE.NONE:
            default:
                return null
        }
    }

    return (
        <div
            className={`address-list-overlay-dznts3 ${addressListMessage ? "" : "collapsed"}`}
            onClick={() => {
                setAddressListMessage(ADDRESS_LIST_MESSAGE.NONE)
                setAddressListLeadsExcluded(null)
            }}
        >
            <div
                className="modal"
                onClick={(e) => {
                    e.stopPropagation()
                }}
                {...xdQAAttribute('modal', 'address list modal')}
            >
                <div className="header">
                    <IconAddressList {...{addressListMessage}} />
                    {addressListMessage}
                    <FontAwesomeIcon
                        className="icon close"
                        icon={faClose}
                        onClick={() => {
                            setAddressListLeadsExcluded(null)
                            setAddressListLeadsIncluded(null)
                            setAddressListMessage(ADDRESS_LIST_MESSAGE.NONE)
                        }}
                        {...xdQAAttribute('icon', 'close address list modal')}
                    />
                </div>
                {
                    Array.isArray(addressListLeadsExcluded) &&
                    addressListLeadsExcluded.length > 0 &&
                    <div className="leads-excluded">
                        <hr />
                        <div className="sub-header">
                            {subHeaderLeadsExcluded()}
                        </div>
                        {
                            addressListLeadsExcluded.map((leadExcluded, i) => {
                                return (
                                    <div
                                        key={i}
                                        className='lead-excluded'
                                        {...xdQAAttribute('text', 'lead excluded')}
                                    >
                                        {leadExcluded.name}
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    showConfirmationControls(addressListMessage) &&
                    <div className="controls">
                        {
                            Array.isArray(addressListLeadsIncluded) &&
                            addressListLeadsIncluded.length > 0
                            ?   <>
                                    <button
                                        className="cancel"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setAddressListLeadsExcluded(null)
                                            setAddressListLeadsIncluded(null)
                                            setAddressListMessage(ADDRESS_LIST_MESSAGE.NONE)
                                        }}
                                        {...xdQAAttribute('button', 'cancel address list')}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="primary"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setAddressListLeadsExcluded(null)
                                                setAddressListMessage(ADDRESS_LIST_MESSAGE.NONE)
                                                createMailingList(addressListLeadsIncluded)
                                            }}
                                            {...xdQAAttribute('button', 'create address list')}
                                    >
                                        Create
                                    </button>
                                </>
                            :   <button
                                    className="primary"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setAddressListLeadsExcluded(null)
                                        setAddressListLeadsIncluded(null)
                                        setAddressListMessage(ADDRESS_LIST_MESSAGE.NONE)
                                    }}
                                    {...xdQAAttribute('button', 'cancel address list')}
                                >
                                    Cancel
                                </button>
                        }
                    </div>

                }
            </div>
        </div>
    )
}

const showConfirmationControls = (addressListMessage) => {
    switch(addressListMessage) {
        case ADDRESS_LIST_MESSAGE.PENDING:
        case ADDRESS_LIST_MESSAGE.ERROR:
        case ADDRESS_LIST_MESSAGE.INVALID:
            return true
        case ADDRESS_LIST_MESSAGE.VALID:
        case ADDRESS_LIST_MESSAGE.NONE:
        default:
            return false
    }
}

export const ADDRESS_LIST_MESSAGE = {
    INVALID: 'Unable to create address list',
    VALID: 'Address list created successfully',
    PENDING: 'Create address list',
    ERROR: 'Error creating address list',
    NONE: null
}

const IconAddressList = ({addressListMessage}) => {
    let classIcon = ''
    let iconAddressList = faClose

    switch(addressListMessage) {
        case ADDRESS_LIST_MESSAGE.VALID:
            classIcon = 'success'
            iconAddressList = faCheck
            break
        case ADDRESS_LIST_MESSAGE.PENDING:
            classIcon = 'caution'
            iconAddressList = faWarning
            break
        case ADDRESS_LIST_MESSAGE.ERROR:
        case ADDRESS_LIST_MESSAGE.INVALID:
            classIcon = 'danger'
            iconAddressList = faBan
            break
        case ADDRESS_LIST_MESSAGE.NONE:
        default:
            break
    }

    return (
        <FontAwesomeIcon
            className={`icon ${classIcon}`}
            icon={iconAddressList}
            {...xdQAAttribute('icon', classIcon)}
        />
    )
}
